import {
  configureStore,
  ThunkAction,
  Action,
  isFulfilled
} from '@reduxjs/toolkit';
import { enhancedApi } from './api';
import { isRejectedWithValue } from '@reduxjs/toolkit';
import type { MiddlewareAPI, Middleware } from '@reduxjs/toolkit';
import ErrorModalSlice, { showErrorModal } from '../features/ErrorModalSlice';
import ToastsSlice, {
  addErrorToast,
  addSuccessToast
} from '../features/ToastsSlice';
import { datadogRum } from '@datadog/browser-rum';

/**
 * Log a warning and show a toast!
 */

/**
 * Log a warning and show a toast!
 */
export const rtkQueryErrorLogger: Middleware =
  (api: MiddlewareAPI) => (next) => (action) => {
    // RTK Query uses `createAsyncThunk` from redux-toolkit under the hood, so we're able to utilize these matchers!
    if (isFulfilled(action)) {
      if (action.meta.arg.type === 'mutation') {
        if (
          action.meta.arg.endpointName !== undefined &&
          action.meta.arg.endpointName.includes('Create')
        ) {
          api.dispatch(
            addSuccessToast({
              msg: 'Created Successfully',
              duration: 3000
            })
          );
        }
        if (
          action.meta.arg.endpointName !== undefined &&
          action.meta.arg.endpointName.includes('Sync')
        ) {
          api.dispatch(
            addSuccessToast({
              msg: 'Synced Successfully',
              duration: 3000
            })
          );
        }
        if (
          action.meta.arg.endpointName !== undefined &&
          action.meta.arg.endpointName.includes('Delete')
        ) {
          api.dispatch(
            addSuccessToast({
              msg: 'Removed Successfully',
              duration: 3000
            })
          );
        }

        if (
          action.meta.arg.endpointName !== undefined &&
          action.meta.arg.endpointName.includes('Update')
        ) {
          api.dispatch(
            addSuccessToast({
              msg: 'Updated Successfully',
              duration: 3000
            })
          );
        }
      }
      // api.dispatch(addErrorToast({ msg: err, duration: 8000 }));
    } else if (isRejectedWithValue(action)) {
      // console.log('Error');
      const err = action.payload.data?.message
        ? action.payload.status + ': ' + action.payload.data.message
        : action.payload.error;

      if (action.payload.status === 400) {
        api.dispatch(addErrorToast({ msg: err, duration: 8000 }));
      } else {
        api.dispatch(
          showErrorModal({ msg: err, status: action.payload.status })
        );
      }
      datadogRum.addError(err);
      // toast.warn({ title: 'Async error!', message: action.error.data.message })
    }

    return next(action);
  };

export const store = configureStore({
  reducer: {
    [enhancedApi.reducerPath]: enhancedApi.reducer,
    errorModal: ErrorModalSlice,
    toasts: ToastsSlice
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware()
      .concat(enhancedApi.middleware)
      .concat(rtkQueryErrorLogger)
  // .concat(logger)
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;
